import AuthService from './authService';
const auth = new AuthService();
export default auth;
